import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const RequestQuote = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4584 45.8333C10.625 45.8333 9.89587 45.5208 9.27087 44.8958C8.64587 44.2708 8.33337 43.5416 8.33337 42.7083V7.29163C8.33337 6.45829 8.64587 5.72913 9.27087 5.10413C9.89587 4.47913 10.625 4.16663 11.4584 4.16663H30.2605L41.6667 15.5729V42.7083C41.6667 43.5416 41.3542 44.2708 40.7292 44.8958C40.1042 45.5208 39.375 45.8333 38.5417 45.8333H11.4584ZM11.4584 15.5729V7.29163V42.7083V15.5729ZM23.4375 39.5312V37.4479H18.75V34.3229H28.125V30.677H20.3125C19.8612 30.677 19.4879 30.5295 19.1927 30.2343C18.8976 29.9392 18.75 29.5659 18.75 29.1145V22.3437C18.75 21.8923 18.8976 21.5191 19.1927 21.2239C19.4879 20.9288 19.8612 20.7812 20.3125 20.7812H23.4375V18.6979H26.5625V20.7812H31.25V23.9062H21.875V27.552H29.6875C30.1389 27.552 30.5122 27.6996 30.8073 27.9947C31.1025 28.2899 31.25 28.6632 31.25 29.1145V35.8854C31.25 36.3368 31.1025 36.71 30.8073 37.0052C30.5122 37.3003 30.1389 37.4479 29.6875 37.4479H26.5625V39.5312H23.4375ZM27.6563 15.5729V7.29163H11.4584V42.7083H38.5417V15.5729H27.6563Z"
        fill={color}
      />
    </svg>
  )
}
